module.exports = __webpack_public_path__ + "files/31f48873f1db920ffaa8392fa691489c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/close.png
 ** module id = 807
 ** module chunks = 0
 **/